export enum RR_FILTER_TYPE {
  TEXT_SEARCH,
  DROPDOWN_SELECT,
  DATE_RANGE,
  CHECKBOX_SELECT,
  RADIO_SELECT,
  MULTI_SELECT,
  TAGS,
}
